import { createContext, useContext } from "react";
export const NotificationsContext = createContext(null);
export function useNotificationsContext() {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error("useNotificationsContext must be used within a NotificationsProvider");
  }
  return context;
}